<template>
  <div>
    <b-form-group v-if="isNoPenny != null" label-align="left" :label="$t(isNoPenny.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-checkbox size="lg" switch class="mt-2" v-model="isNoPenny.raw_values[0].value" unchecked-value="0" value="1"/>
    </b-form-group>
    <b-form-group label-align="left" v-if="minPayment" :label="$t(minPayment.description)" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="minPayment.raw_values[0].value"/>
    </b-form-group>
    <md-button class="md-raised" @click="SaveAll" >{{ $t('Save') }}</md-button>
  </div>
</template>

<script>
export default {
  methods: {
    SaveAll () {
      this.SaveSystemSetting(this.isNoPenny)
      this.SaveSystemSetting(this.minPayment)
      this.$root.$emit('makeToasts')
      setTimeout(this.$store.dispatch, 1000, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 15, object_id: 0})
    },
    SaveSystemSetting (setting) {
      let tmp = JSON.parse(JSON.stringify(setting))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(setting.raw_values[0].value)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        }
      })
    }
  },
  computed: {
    registrySettings () {
      return JSON.parse(JSON.stringify(this.$store.getters['Settings/REGISTRY_SETTINGS']))
    },
    isNoPenny () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'customer_portal_no_penny'
      })
      return tmp.length ? tmp[0] : null
    },
    minPayment () {
      let tmp = this.registrySettings.filter(el => {
        return el.name === 'customer_portal_min_payment'
      })
      return tmp.length ? tmp[0] : null
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 15, object_id: 0})
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/paymentSystems/settings.vue